var _a;
import { __assign, __rest } from "tslib";
import { reduxKey } from './constants';
import { StreamType } from './types';
import { STREAM__DELETE_STREAM } from './base/actions';
import withCursorStreamReducer from './withCursor/reducer';
import withOffsetStreamReducer from './withOffset/reducer';
import { STREAM__WITH_CURSOR__INITIALIZE } from './withCursor/actions';
import { STREAM__WITH_OFFSET__INITIALIZE } from './withOffset/actions';
var defaultState = {};
var reducers = (_a = {},
    _a[reduxKey] = function (state, action) {
        var _a;
        if (state === void 0) { state = defaultState; }
        var type = action.type;
        var _b = action.payload
            ? action.payload
            : action, streamId = _b.streamId, actionStreamType = _b.streamType;
        if (!streamId) {
            return state;
        }
        var _c = state, _d = streamId, streamState = _c[_d], rest = __rest(_c, [typeof _d === "symbol" ? _d : _d + ""]);
        if (type === STREAM__DELETE_STREAM) {
            return rest;
        }
        var streamType = actionStreamType || (streamState && streamState.streamType);
        var newStreamState;
        switch (streamType) {
            case StreamType.WITH_CURSOR:
                newStreamState = withCursorStreamReducer(streamState, action);
                break;
            case StreamType.WITH_OFFSET:
                newStreamState = withOffsetStreamReducer(streamState, action);
                break;
            default:
                return state;
        }
        if (newStreamState === streamState) {
            return state;
        }
        // We should only create a stream from the init action, everything else
        // should end as a noop on the store.
        if (!state[streamId] &&
            type !== STREAM__WITH_CURSOR__INITIALIZE &&
            type !== STREAM__WITH_OFFSET__INITIALIZE) {
            return state;
        }
        return __assign(__assign({}, state), (_a = {}, _a[streamId] = newStreamState, _a));
    },
    _a);
export default reducers;
export { reduxKey };
//# sourceMappingURL=reducers.js.map